import { memo } from 'react';
import { motion } from 'motion/react';
import { useGetParams } from '../../hooks/useGetParams';
import styles from './Advt.module.css';

import posterDefault from '../../assets/images/advtBgPoster.webp';
import bgDefaultVideo from '../../assets/video/advtBg.webm';
import logo from '../../assets/images/logo.png';
import { MadeIactivePro } from '../MadeIactivePro/MadeIactivePro';

const Advt = memo(() => {
  const { title, qrCode1, qrCode2, paddingQR, sizeQR, titleFontSize } =
    useGetParams();

  return (
    <div className={styles.wrapper}>
      <motion.img
        initial={{ y: '-100%' }}
        animate={{ y: 0 }}
        transition={{ duration: 1 }}
        src={logo}
        alt="logo"
        className={styles.logo}
      />

      <div className={styles.wrapperTitleBlock}>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 0.95, 1] }}
          transition={{ duration: 3.5, times: [0, 0.29, 1] }}
          className={styles.titleBlock}
        >
          <div className={styles.leftTop} />
          <div className={styles.rightTop} />
          <div className={styles.rightBottom} />
          <div className={styles.leftBottom} />
        </motion.div>

        <div className={styles.titleTexts}>
          <motion.div
            initial={{ y: '45%', scale: 0 }}
            animate={{ y: 0, scale: 1 }}
            transition={{
              y: { duration: 0.8, delay: 2 },
              scale: { duration: 1, delay: 0 },
            }}
            className={styles.prizes}
          >
            РОЗЫГРЫШ ПРИЗОВ
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 2.8 }}
            className={styles.alhimiya}
          >
            ПРИСЫЛАЙТЕ СЛОВО <span>«Алхимия»</span>
          </motion.div>
        </div>
      </div>

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0.03, 1] }}
            transition={{
              opacity: {
                duration: 1.5,
                delay: 1,
                times: [0, 0.33, 0.66, 1],
                ease: ['easeOut', 'easeOut', 'easeOut'],
              },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0.03, 1] }}
            transition={{
              opacity: {
                duration: 1.5,
                delay: 1,
                times: [0, 0.33, 0.66, 1],
                ease: ['easeOut', 'easeOut', 'easeOut'],
              },
            }}
            className={styles.qrCode}
            style={{
              padding: `${paddingQR}rem`,
              background: paddingQR === '0' && 'none',
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode2" />
          </motion.div>
        )}
      </div>

      <MadeIactivePro />

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.bgVideo}
        poster={posterDefault}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>
    </div>
  );
});

export default Advt;
